import styles from './StepsRegistrationPassport.module.css';
import imageStep1 from '../../assets/img/create-account-step1-passport.png';
import imageStep2 from '../../assets/img/create-account-step2-passport.png';
import imageStep3 from '../../assets/img/create-account-step3-passport.png';

export const StepsRegistrationPassport = () => {
  return (
    <div className={styles.cards}>
        <div className={styles.card}>
            <img src={imageStep1} alt='Pasaporte' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 1</h4>
            <p className={styles.card__description}>Toma una fotografía de tu pasaporte.</p>

        </div>
        <div className={styles.card}>
            <img src={imageStep2} alt='Tu con tu pasaporte' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 2</h4>
            <p className={styles.card__description}>Toma una fotografía de ti junto a tu pasaporte, en donde se vea tu rostro y la parte frontal de tu documento.</p>
        </div>
        <div className={styles.card}>
            <img src={imageStep3} alt='Validamos tus datos' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 3</h4>
            <p className={styles.card__description}>Validaremos tus datos en 48 horas hábiles aproximadamente.</p>
        </div>
    </div>
  )
}
